import { Flex, Skeleton } from "antd";

export default function ReviewLoading() {
  return (
    <div className="bg-white p-6 border border-theme-zinc-200 rounded-lg">
      {/* Header Section Skeleton */}
      <div className="mb-6 flex flex-col">
        <Skeleton.Input active size="large" className="!w-96 mb-2" />
        <Skeleton.Input active size="small" className="!w-64" />
      </div>

      {/* Rating Overview Skeleton */}
      <div className="mb-6 pb-6 border-b border-gray-200">
        <div className="md:flex items-start justify-between gap-36 space-y-6 md:space-y-0">
          {/* Overall Rating Skeleton */}
          <Flex className="flex-col">
            <Skeleton.Input active size="large" className="!w-24 !h-16 mb-2" />
            <Skeleton.Input active size="small" className="!w-32" />
          </Flex>

          {/* Rating Bars Skeleton */}
          <div className="flex-1">
            {[1, 2, 3, 4, 5].map((item) => (
              <Flex align="center" gap={20} key={item} className="mb-2">
                <Skeleton.Input active size="small" className="!w-32" />
                <Skeleton.Input active size="small" className="!w-56" />
                <Skeleton.Input active size="small" className="!w-8" />
              </Flex>
            ))}
          </div>
        </div>
      </div>

      {/* Reviews List Skeleton */}
      <div className="space-y-3">
        {[1, 2, 3].map((item) => (
          <div
            key={item}
            className="pb-3 border-b border-theme-zinc-200 last:border-0"
          >
            <Flex gap={16} wrap>
              <Skeleton.Avatar active size={48} />
              <div className="flex-1">
                <Flex align="center" gap={10} className="mb-1">
                  <Skeleton.Input active size="small" className="!w-40" />
                  <Skeleton.Input active size="small" className="!w-32" />
                </Flex>
                <Skeleton.Input active size="small" className="!w-24 mt-1" />
              </div>
            </Flex>
            <Flex gap={12} className="mt-5 flex-col">
              <Skeleton.Button className="!h-5 !w-52" active />
              <Skeleton.Button className="!h-5 !w-96" active />
              <Skeleton.Button className="!h-5 !w-64" active />
            </Flex>
          </div>
        ))}
      </div>
    </div>
  );
}
